import Status from "../ValueObject/Status";

export default class Document {
    public constructor(
        private readonly id: string,
        private readonly name: string,
        private readonly filesize: number,
        private readonly text: string,
        private readonly entityChanged: number,
        private readonly dateDownloaded: number,
        private readonly timeLapse: number,
        private readonly lastVerified: number,
        private readonly format: string,
        private description: string,
        private readonly mimetype: string,
        private readonly uuid: string,
        private readonly entityBundle: string,
        private status: Status,
        private position: number
    ) {
    }

    public getId(): string {
        return this.id;
    }

    public getIdInteger(): number {
        return parseInt(this.id);
    }

    public getName(): string {
        return this.name;
    }

    public getFilesize(): number {
        return this.filesize;
    }

    public getText(): string {
        return this.text;
    }

    public getEntityChanged(): number {
        return this.entityChanged;
    }

    public getDateDownloaded(): number {
        return this.dateDownloaded;
    }

    public getTimeLapse(): number {
        return this.timeLapse;
    }

    public getLastVerified(): number {
        return this.lastVerified;
    }

    public getFormat(): string {
        return this.format;
    }

    public getDescription(): string {
        return this.description;
    }

    public setDescription(description: string): void {
        this.description = description;
    }

    public getMimetype(): string {
        return this.mimetype;
    }

    public getUuid(): string {
        return this.uuid;
    }

    public getEntityBundle(): string {
        return this.entityBundle;
    }

    public getStatus(): Status {
        return this.status;
    }

    public setStatus(status: Status): void {
        this.status = status;
    }

    public getPosition(): number {
        return this.position;
    }

    public setPosition(position: number): void {
        this.position = position;
    }
}